import { Flex, IconButton, Select, Textarea, Tooltip } from '@chakra-ui/react';
import isUndefined from 'lodash-es/isUndefined';
import { Lightbulb } from 'lucide-react';

export type HintType = { message: string; type: string; inactivity_seconds?: number } | undefined;

enum HintMessageType {
  AFTER_INACTIVITY = 'AFTER_INACTIVITY',
  IMMEDIATELY = 'IMMEDIATELY',
}

type Props = {
  hint: HintType;
  updateHint: (hint: HintType) => void;
};

export function QuizHint({ hint, updateHint }: Props) {
  const inactivity_seconds = hint?.inactivity_seconds || 5;

  const updateHintHandler = (hint: HintType) => {
    updateHint(
      hint
        ? {
            message: hint.message,
            type: hint.type,
            inactivity_seconds:
              hint.type === HintMessageType.AFTER_INACTIVITY ? inactivity_seconds : 0,
          }
        : undefined,
    );
  };

  return (
    <Flex flexDirection="column" gap={2} mt={4} w="full" alignItems="start">
      <Tooltip label="Offer a hint">
        <IconButton
          fontWeight="normal"
          size="sm"
          variant="outline"
          onClick={(e) => {
            e.stopPropagation();

            if (isUndefined(hint)) {
              updateHintHandler({
                message: '',
                type: HintMessageType.IMMEDIATELY,
              });
            } else {
              updateHintHandler(undefined);
            }
          }}
          rounded="full"
          {...(!isUndefined(hint?.message)
            ? {
                borderColor: 'transparent',
                bg: 'accent',
                color: 'white',
                _hover: {
                  bg: 'accent',
                  opacity: 0.8,
                },
              }
            : {
                borderColor: 'hsla(211, 25%, 84%, 1)',
                bg: 'white',
                color: 'black',
              })}
          aria-label="Offer a hint"
        >
          <Lightbulb size="16" />
        </IconButton>
      </Tooltip>
      {hint ? (
        <>
          <Select
            defaultValue={HintMessageType.IMMEDIATELY}
            color="gray.600"
            rounded="md"
            bg="bg.surface"
            size="sm"
            w="fit-content"
            onChange={(e) =>
              updateHintHandler({
                message: hint?.message || '',
                type: e.target.value as HintMessageType,
              })
            }
            value={hint?.type}
          >
            <option value={HintMessageType.IMMEDIATELY}>All the time</option>
            <option value={HintMessageType.AFTER_INACTIVITY}>
              After {inactivity_seconds} seconds of in activity
            </option>
          </Select>
          <Textarea
            defaultValue={hint?.message}
            placeholder="💡 Write hint here..."
            rows={1}
            onChange={(e) => {
              updateHintHandler({
                message: e.target.value || '',
                type: (hint?.type as HintMessageType) || HintMessageType.IMMEDIATELY,
              });
            }}
          />
        </>
      ) : null}
    </Flex>
  );
}
